import FormFieldViewText from "components/FormFields/ViewText";
import Timestamp from "components/Timestamp";
import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import FormField from "ds/components/Form/Field";
import Link from "ds/components/Link";

import { ANSIBLE_STATUS_BADGE_VARIANT } from "../constants";
import { ConfigNode } from "../../types";

type ConfigManagementTreeGridDrawerDetailsProps = {
  task: ConfigNode;
};

const ConfigManagementTreeGridDrawerDetails = ({
  task,
}: ConfigManagementTreeGridDrawerDetailsProps) => {
  return (
    <>
      <FormFieldViewText label="Task name" value={task.taskName} />
      {task.hostName && <FormFieldViewText label="Host name" value={task.hostName} />}
      {task.playbookName && <FormFieldViewText label="Playbook" value={task.playbookName} />}
      {task.roleName && <FormFieldViewText label="Role" value={task.roleName} />}
      {task.status && (
        <FormField label="Status">
          <Box gap="medium">
            <Badge
              variant={ANSIBLE_STATUS_BADGE_VARIANT[task.status]}
              type="strong"
              text={task.status}
            />
            {task.checkMode && <Badge variant="gray" type="strong" text="CHECK MODE" />}
          </Box>
        </FormField>
      )}
      {task.timestamp && (
        <Box justify="start" margin="x-large 0 0 0">
          <FormField label="Performed at">
            <Timestamp timestamp={task.timestamp} />
          </FormField>
        </Box>
      )}
      {task.runId && task.stackId && (
        <Box justify="start" margin="x-large 0 0">
          <Link href={`/stack/${task.stackId}/run/${task.runId}`}>Go to Run</Link>
        </Box>
      )}
    </>
  );
};

export default ConfigManagementTreeGridDrawerDetails;
